export default __webpack_public_path__ + "static/media/hht2_ep14_speaking_01.5b3cec6b.png";